if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

if (typeof Shopify.theme.customProductList === 'undefined') {
  Shopify.theme.customProductList = {
    listen: () => {
      let customProductListSections = document.querySelectorAll('.section-custom-product-list');
      customProductListSections.forEach(section => {
        const list = section.querySelector('.featured-collection__items');
        if (!list) return false;
        const cardsUrl = list.getAttribute('data-cards-url');
        const maxItems = list.getAttribute('data-max-items');
        if (!cardsUrl || cardsUrl.length < 1) return false;
        fetch(`${cardsUrl}`).then(res => {
          if (res.ok) {
            return res.text();
          }
        }).then(data => {
          if (data !== null && data !== void 0 && data.includes('product-card')) {
            let div = document.createElement('div');
            div.innerHTML = data;
            let items = Array.from(div.querySelectorAll('.product-card'));
            div.innerHTML = div.querySelector('#shopify-section-collection-by-tag').innerHTML;

            if (maxItems > 0) {
              const trimmed = items.slice(0, maxItems);
              div.innerHTML = '';
              trimmed.forEach(element => {
                div.appendChild(element);
              });
            }

            list.innerHTML = div.innerHTML;
          } else {
            section.remove();
          }
        }).catch(e => {
          console.error(e);
          section.remove();
        });
      });
    }
  };
  Shopify.theme.customProductList.listen();
}
